import { Banner, Text } from "@medentic/polaris-react";
import { useTranslation } from "react-i18next";

const NotPlannedBanner = () => {
  const { t } = useTranslation();

  return (
    <Banner title={t("notPlannedBanner.title")} tone="info">
      <Text as="p" tone="subdued">
        {t("notPlannedBanner.description")}
      </Text>
    </Banner>
  );
};

export default NotPlannedBanner;
